import { useState } from "react";
import { useRouter } from "next/router";
import { useUser } from "@auth0/nextjs-auth0/client";
import axios from "axios";
export default function StepResolution({ setSteps, outsetaUserId }) {
  const [message, setMessage] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const route = useRouter();
  const { user } = useUser();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(false);
    const resolution = e.target.querySelector('[name="resolution"]').value;
    const source = e.target.querySelector('[name="source"]').value;

    if (resolution === "") {
      setMessage({
        type: "error",
        msg: "Resolution must be selected!",
      });
      return;
    }
    try {
      new URL(source);
      setSubmitting(true);
      await axios({
        url: `${location.origin}/api/case-submission`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer UK-t9E1O3sJLf-2E`, // oof - api key in frontend code :(
        },
        data: {
          url: "https://api.airtable.com/v0/appUoUXV68dbvvCHx/Case%20Resolution%20Submission",
          records: [
            {
              fields: {
                "User ID": outsetaUserId || "undefined",
                "User email": user.email || user.name || "undefined",
                "Case Slug": `/${route.query.slug}`,
                Source: source,
                Resolution: resolution,
              },
            },
          ],
        },
      });
      setSubmitting(false);
      setMessage({
        type: "success",
        msg: "Case resolution has been submitted successfully.",
      });
    } catch (error) {
      console.log(error);
      setMessage({
        type: "error",
        msg: "Source url is not valid!",
      });
    }
  };

  return (
    <div className="-mt-5">
      <button
        className="text-red underline hover:no-underline mb-10"
        onClick={() => setSteps("addSource")}
      >
        {"<"}Back{" "}
      </button>
      <h1 className="text-2xl font-bold mb-6">Case Resolution</h1>
      <p>Thank you for letting us know this case has been resolved.</p>

      <form className="mt-10" onSubmit={handleSubmit}>
        <div className="mb-5">
          <label className="block font-bold text-xs text-gray-400 mb-2">
            What is the resolution?
          </label>
          <div className="select-custom">
            <select className="w-full p-2" name="resolution">
              <option value="" style={{ display: "none" }}>
                Choose an option
              </option>
              <option value="Remains have been found (No longer a missing person case)">
                Remains have been found (No longer a missing person case)
              </option>
              <option value="Case has been closed / resolved">
                Case has been closed / resolved
              </option>
              <option value="Suspect arrested/charged">
                Suspect arrested/charged
              </option>
              <option value="Ruled a homicide">Ruled a homicide</option>
              <option value="Ruled a suicide or accidental death">
                Ruled a suicide or accidental death
              </option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>
        <div className="mb-5">
          <label className="block font-bold text-xs text-gray-400 mb-2">
            Add a link to a source for the resolution
          </label>
          <input
            type="ulr"
            placeholder="Source URL"
            className="border px-3 py-2 w-full text-base border-gray-250"
            name="source"
          />
        </div>
        {message && (
          <div
            className={message.type === "error" ? "text-red" : "text-green-600"}
          >
            {message.msg}
          </div>
        )}
        <div className="flex">
          <button
            className={`ml-auto font-bold rounded-md px-10 py-2 transition mt-5  ${
              submitting
                ? "cursor-not-allowed bg-gray-200 text-gray-400"
                : "hover:bg-yellow-600 bg-yellow-400 text-white"
            }`}
            type="submit"
            disabled={setSubmitting}
          >
            {submitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
}
